package com.mxpainting.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.mxpainting.Strings
import com.mxpainting.rememberLanguage
import com.mxpainting.components.sections.Nav
import com.mxpainting.components.sections.TopBar
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun PageLayout(content: @Composable () -> Unit) {
    val language by rememberLanguage()
    
    // SEO Side Effect
    androidx.compose.runtime.SideEffect {
        kotlinx.browser.window.document.title = Strings.pageTitle[language] ?: "MX Painting"
        val metaDesc = kotlinx.browser.window.document.querySelector("meta[name='description']")
        metaDesc?.setAttribute("content", Strings.pageDescription[language] ?: "")
    }

    Column(Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally) {
        // Top Bar
        TopBar()

        // Navigation
        Nav()

        // Main Content Area
        Box(Modifier.fillMaxWidth()) {
            content()
        }

        // Footer
        Footer(Modifier.classNames("container-fluid", "bg-dark", "text-light", "footer", "mt-5", "py-5").toAttrs()) {
            Div(Modifier.classNames("container", "py-5").toAttrs()) {
                Div(Modifier.classNames("row", "g-5").toAttrs()) {
                    Div(Modifier.classNames("col-lg-4", "col-md-6").toAttrs()) {
                        H4(Modifier.classNames("text-white", "mb-4").toAttrs()) { Text(Strings.footerOffice[language] ?: "") }
                        P(Modifier.classNames("mb-2").toAttrs()) {
                            I(Modifier.classNames("fa", "fa-map-marker-alt", "me-3").toAttrs()) {}
                            Text(Strings.contactOfficeCardDescription[language] ?: "")
                        }
                        P(Modifier.classNames("mb-2").toAttrs()) {
                            A(href = "tel:2508849487", attrs = Modifier.classNames("footer-link").toAttrs()){
                                I(Modifier.classNames("fa", "fa-phone-alt", "me-3").toAttrs()) {}
                                Text(Strings.contactPhoneCardDescription[language] ?: "")
                            }
                        }
                        P(Modifier.classNames("mb-2").toAttrs()) {
                            A(href = "mailto:mxpainting@gmail.com", attrs = Modifier.classNames("footer-link").toAttrs()){
                            I(Modifier.classNames("fa", "fa-envelope", "me-3").toAttrs()) {}
                            Text(Strings.contactEmailCardDescription[language] ?: "")
                        }
                        }
                    }
                    Div(Modifier.classNames("col-lg-4", "col-md-6").toAttrs()) {
                        H4(Modifier.classNames("text-white", "mb-4").toAttrs()) { Text(Strings.footerQuickLinks[language] ?: "") }
                        A(href = "/", attrs = Modifier.classNames("btn", "btn-link").toAttrs()) { Text(Strings.home[language] ?: "") }
                        A(href = "/services", attrs = Modifier.classNames("btn", "btn-link").toAttrs()) { Text(Strings.services[language] ?: "") }
                        A(href = "/contact", attrs = Modifier.classNames("btn", "btn-link").toAttrs()) { Text(Strings.contact[language] ?: "") }
                    }
                    Div(Modifier.classNames("col-lg-4", "col-md-6").toAttrs()) {
                        H4(Modifier.classNames("text-white", "mb-4").toAttrs()) { Text(Strings.footerFollowUs[language] ?: "") }
                        Div(Modifier.classNames("d-flex", "pt-2").toAttrs()) {
                            A(href = "https://www.facebook.com/MX-Painting-931817703684196/", attrs = Modifier.classNames("btn", "btn-square", "btn-outline-light", "rounded-circle", "me-2").toAttrs()) {
                                I(Modifier.classNames("fab", "fa-facebook-f").toAttrs()) {}
                            }
                            A(href = "https://www.instagram.com/mxpainting/", attrs = Modifier.classNames("btn", "btn-square", "btn-outline-light", "rounded-circle", "me-2").toAttrs()) {
                                I(Modifier.classNames("fab", "fa-instagram").toAttrs()) {}
                            }
                        }
                    }
                }
            }
        }
    }
}
